import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ThreeThings.css';

// ThreeThings — THE "DO THESE THREE" CARD. 2026-09-02.
//
// Braeden: "(ever watch a youtube video like that when like 3 do these 3
// things to win pop up, for things she needs to know) like she says first i
// want to do a full dive into the full scope, the second thing i need how much
// we currently have preped, and third what your absolute most desired result
// is."
//
// It appears while she is naming their project — a GENERATION is running, and
// he was explicit that she has to walk them through what is happening rather
// than sit in silence. So the card does two jobs at once: it fills the wait
// with something true, and it sets the shape of the conversation that follows
// (status as a visual widget, never a wall of text).
//
// Fixed overlay in the same band FirstLook uses. The Ask-page layout is locked
// (LAYOUT.md): header, orb, chat and input bar do not move. Pointer-events
// none on the frame so nothing behind it is blocked.

export default function ThreeThings({ items, title, onDone }) {
  const [shown, setShown] = useState(0);
  // `onDone` is an inline arrow in App.jsx, so its identity changes on every
  // App render — and App renders constantly while she is speaking or
  // listening. With it in the effect deps, every render tore the timers down
  // and re-armed them, so the rows kept restarting. Held in a ref, the effect
  // keys on `items` alone.
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  // The three land one after another, on her cadence, not all at once — a
  // list that appears whole is read as decoration; one that arrives is read.
  useEffect(() => {
    if (!items || !items.length) { setShown(0); return undefined; }
    setShown(0);
    const ts = items.map((_, i) => setTimeout(() => setShown(i + 1), 420 + i * 900));
    // It comes down on its own. Long enough to read three lines twice; short
    // enough that it never becomes furniture.
    const off = setTimeout(() => { try { doneRef.current?.(); } catch (_) {} }, 26000);
    return () => { ts.forEach(clearTimeout); clearTimeout(off); };
  }, [items]);

  if (!items || !items.length) return null;

  // PORTALED TO <body>. Measured live 9/2: the card rendered with all three
  // rows in the DOM, at the right size, and was invisible — the chat sheet
  // (`.aria-glass-chat`, fixed, z-index 30) lives inside `.app-content`,
  // which is its own stacking context, and this card was rendered deeper
  // inside the Ask page's subtree. A z-index of 10000 only competes within
  // its own context, so it lost to a 30. From <body> it sits in the root
  // context, above `.app-content` (z-index 1), the same way a modal does.
  return createPortal(
    <div className="tt" role="status" aria-live="polite">
      <div className="tt__card">
        {title && <div className="tt__title">{title}</div>}
        <ol className="tt__list">
          {items.map((it, i) => (
            <li key={i} className={'tt__row' + (i < shown ? ' is-in' : '')}>
              <span className="tt__n">{i + 1}</span>
              <span className="tt__k">{it.k}</span>
              <span className="tt__t">{it.t}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>,
    document.body,
  );
}
